import useOnClickOutside from '@/hooks/useOnClickOutside';
import { Dispatch, SetStateAction, useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import EVMImage from '../../assets/images/EVM-image.png';
import { useEvmConnect } from '../../hooks/useConnectEvm';
import { MetamaskIconSmall, OwalletIcon } from '../icons/wallets';

const ConnectWalletModal = ({
  isVisible,
  setIsVisible,
}: {
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
}) => {
  const {
    loadingConnectMetamask,
    loadingConnectOwalletEVM,
    connectMetamaskWallet,
    connectOwalletEVM,
  } = useEvmConnect();
  const evmLoginRef = useRef();

  useOnClickOutside(evmLoginRef, () => {
    setIsVisible(false);
  });

  const CONNECTORS = [
    {
      id: 'owallet-evm',
      name: 'OWallet',
      icon: <OwalletIcon width={32} height={38} />,
      loading: loadingConnectOwalletEVM,
      connect: async () => {
        await connectOwalletEVM();
        setIsVisible(false);
      },
      network: (
        <div className="flex items-center gap-1">
          <img src={EVMImage} width={42} height={24} />
          <span className="text-14 text-mercury-900">EVM</span>
        </div>
      ),
    },
    {
      id: 'metamask',
      name: 'Metamask',
      icon: <MetamaskIconSmall width={32} height={38} />,
      loading: loadingConnectMetamask,
      connect: async () => {
        await connectMetamaskWallet();
        setIsVisible(false);
      },
      network: (
        <div className="flex items-center gap-1">
          <img src={EVMImage} width={42} height={24} />
          <span className="text-14 text-mercury-900">EVM</span>
        </div>
      ),
    },
  ];

  return (
    <div
      className={twMerge(
        'fixed w-screen inset-0 flex items-center justify-center z-50 backdrop-blur-md',
        !isVisible && 'hidden',
      )}
    >
      <div className="p-5 bg-[#13141D] rounded-xl w-[400px]" ref={evmLoginRef}>
        <div className="relative mb-10">
          <h3 className="flex-1 text-center text-[24px] font-semibold text-[#E8E9EE]">
            Connect Wallet
          </h3>

          <button
            className="absolute right-3 top-1/2 -translate-y-1/2"
            onClick={() => setIsVisible(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M13.5909 12.5L18.0441 8.04687C18.2554 7.8359 18.3743 7.54962 18.3745 7.25099C18.3748 6.95237 18.2564 6.66587 18.0455 6.45453C17.8345 6.24319 17.5482 6.12431 17.2496 6.12404C16.951 6.12378 16.6645 6.24215 16.4531 6.45312L12 10.9062L7.54687 6.45312C7.33553 6.24178 7.04888 6.12305 6.75 6.12305C6.45111 6.12305 6.16447 6.24178 5.95312 6.45312C5.74178 6.66447 5.62305 6.95111 5.62305 7.25C5.62305 7.54888 5.74178 7.83553 5.95312 8.04687L10.4062 12.5L5.95312 16.9531C5.74178 17.1645 5.62305 17.4511 5.62305 17.75C5.62305 18.0489 5.74178 18.3355 5.95312 18.5469C6.16447 18.7582 6.45111 18.8769 6.75 18.8769C7.04888 18.8769 7.33553 18.7582 7.54687 18.5469L12 14.0937L16.4531 18.5469C16.6645 18.7582 16.9511 18.8769 17.25 18.8769C17.5489 18.8769 17.8355 18.7582 18.0469 18.5469C18.2582 18.3355 18.3769 18.0489 18.3769 17.75C18.3769 17.4511 18.2582 17.1645 18.0469 16.9531L13.5909 12.5Z"
                fill="#E8E9EE"
              />
            </svg>
          </button>
        </div>
        <div className="flex flex-col gap-3 items-center justify-center py-4">
          {CONNECTORS.map((connector) => {
            return (
              <div
                key={connector.id}
                className="mb-2 flex h-16 w-full items-center justify-between rounded-[14px] bg-[#1A1C28] p-4 outline outline-[1px] outline-[#30344A]"
              >
                <div className="flex items-center gap-4 text-[#E8E9EE]">
                  {connector.icon}
                  <div>
                    <span className="text-[#E8E9EE]">{connector.name}</span>
                    {/* <span className="text-sm text-[#9192A0]">
                      {connector.network}
                    </span> */}
                  </div>
                </div>
                <button
                  className="group flex h-[40px] cursor-pointer items-center justify-center gap-4 rounded-lg bg-[#Fcfcfc] p-2 px-6 hover:bg-[#Fcfcfc]/80"
                  onClick={connector.connect}
                >
                  <span className="text-18 text-[#080A14] max-md:text-14 font-semibold">
                    {connector.loading ? 'Connecting...' : 'Connect'}
                  </span>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ConnectWalletModal;
